var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M6 5a1 1 0 0 0-1 1v11a1 1 0 1 0 2 0V8.414l10.293 10.293a1 1 0 0 0 1.414-1.414L8.414 7H17a1 1 0 1 0 0-2z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }